<ng-container #content />

@if (!element) {
  <ng-content select="[default]"></ng-content>
}

<ng-template
  #visualization
  let-data="data">
  <div
    highcharts-chart
    class="highcharts-light {{ options?.chartCssClasses | chartCssClasses:data }}"
    [Highcharts]="(options?.chartConstructerType | chartConstructor:data) === 'stockChart' ? Highstock : Highcharts"
    [constructorType]="options?.chartConstructerType | chartConstructor:data"
    [sizeStrategy]="options?.chartSizeStrategy"
    [runOutsideAngular]="true"
    [options]="data | transformChartOptions:legacyTransformer:options?.chartOptionsTransformer"></div>
</ng-template>

<ng-template
  #valueDevelopment
  let-data="data">
  <wct-value-development-chart [data]="data" [sizeStrategy]="options?.chartSizeStrategy" />
</ng-template>

<ng-template #doughnut let-data="data">
  <wct-doughnut-chart [data]="data" [sizeStrategy]="options?.chartSizeStrategy"/>
</ng-template>

<ng-template
  #treemap
  let-data="data">
  <app-treemap-chart
    [data]="data"
    [sizeStrategy]="options?.chartSizeStrategy"></app-treemap-chart>
</ng-template>

<ng-template
  #text
  let-content="content"
  let-classes="classes">
  <div
    [classList]="classes"
    [innerHTML]="content"></div>
</ng-template>

<ng-template
  #footnote
  let-content="content"
  let-classes="classes">
  <ul class="sd-footnotes">
    @for (note of content; track note) {
      <li>{{ note }}</li>
    }
  </ul>
</ng-template>

<ng-template
  #solidTable
  let-data="data">
  <wct-solid-table [data]="data" />
</ng-template>

<ng-template
  #simpleTable
  let-data="data">
  <wct-simple-table [data]="data" />
</ng-template>

<ng-template
  #tightTable
  let-data="data">
  <wct-tight-table [data]="data" />
</ng-template>
